import { render } from "./ArrayItems.vue?vue&type=template&id=7e12add7"
import script from "./ArrayItems.vue?vue&type=script&lang=js"
export * from "./ArrayItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__